





































































import Vue from 'vue'
import Component from 'vue-class-component'
import Api from '@/api'
import ModalV2 from '@/components/modals/ModalV2.vue'
import Icon from '@/components/Icon.vue'
import { IFacility, IResident, IUser } from '@zunta/configurations'

@Component({
  components: {
    ModalV2,
    Icon,
  },
  props: {
    chainMigrationData: {
      type: Object,
      default: null
    },
  }
})
export default class MigrateToV2Popup extends Vue {
  get facilityBillingContact () {
    const facility = this.$props.chainMigrationData
      ? (this.$props.chainMigrationData as Partial<IResident>).facility as Partial<IFacility>
      : null

    return facility ? facility.residentBillingContact as Partial<IUser> : null
  }

  redirectUserToV2 () {
    Api.v2.redirectUserToV2()
  }
}

